export default {
  LOGO_IMG_ALT_Y2: 'יד2 לעמוד הבית',
  LOGO_IMG_ALT_Y1: 'יד1 לעמוד הבית',
} as const;
